export enum AdvertisementType {
  HEADER = 'the-aa-leaderboard',
  FOOTER = 'the-aa-billboard',
  INTERSTITIAL = 'the-aa-interstitial',
  MPU = 'the-aa-mpu',
  MOBILEHEADER = 'the-aa-mobile-leaderboard',
  PRINTHEADER = 'the-aa-leaderboard-2',
  MOBILEFOOTER = 'the-aa-mpu-mobile',

  LEADERBOARD = 'leaderboard',
  LEADERBOARD2 = 'leaderboard-2',
  BILLBOARD = 'billboard',
  SIDEMPU = 'mpu',
  MOBILELEADERBOARD = 'mobile-leaderboard',
  MPUMOBILE = 'mpu-mobile'
}

export enum GoogleAdTypes {
  'the-aa-leaderboard' = 'LEADERBOARD',
  'the-aa-leaderboard-2' = 'LEADERBOARD2',
  //'the-aa-mobile-leaderboard' = 'MOBILELEADERBOARD',
  'the-aa-billboard' = 'BILLBOARD',
  'the-aa-interstitial' = 'INTERSTITIAL',
  'the-aa-mpu' = 'SIDEMPU',
  'the-aa-mpu-mobile' = 'MPUMOBILE',
  'the-aa-header-mobile' = 'TOPMOBILE'
}
